  
import Home from "./pages/home";



import logo from "./logo.svg";
import React, { Component, useEffect } from "react"; 
import { Route, Routes, useLocation } from "react-router-dom";
import "./App.css";

function App() {

  // const location = useLocation();

  // useEffect(() => {
  //   if (location.pathname !== '/' && location.pathname.endsWith('/')) {
  //     const newPath = `/data-science-course-one${location.pathname.slice(0, -1)}`;
  //     window.location.replace(newPath);
  //     console.log(newPath);
  //   }
  //   console.log(location);
  // }, [location]);

  return (
    <Routes>
      <Route exact path="/" element={<Home />} />
     
    </Routes>
  );
}

export default App;
